const robot=[
    {
        id:1,
        name:'Leanne Graham',
        username:'leanne',
        email: "Sincere@april.biz"
    },
    {
        id:2,
        name: "Ervin Howell",
        username:'ri',
        email: "Shanna@melissa.tv"
    },
    {
        id:3,
        name: "Clementine Bauch",
        username:'tanu',
        email: "Nathan@yesenia.net"
    },
    {
        id:4,
        name: "Patricia Lebsack",
        username:'tanu',
        email: "Julianne.OConner@kory.org"
    },
    {
        id:5,
        name: "Chelsey Dietrich",
        username:'tanu',
        email: "Lucio_Hettinger@annie.ca"
    },
    {
        id:6,
        name: "Mrs. Dennis Schulist",
        username:'tanu',
        email: "Karley_Dach@jasper.info",
    },
    {
        id:7,
        name: "Kurtis Weissnat",
        username:'tanu',
        email: "Telly.Hoeger@billy.biz"
    },
    {
        id:8,
        name: "Nicholas Runolfsdottir V",
        username:'tanu',
        email: "Sherwood@rosamond.me"
    }
]
export default robot;